import {Component} from "react";
import {COLUMN_STATUS_PROCESSING} from "../../../columns";
import {FaIcon} from "../../../../FaIcon";
import {APP_URL} from "../../../../../settings/local_settings";

const LIVE_META_STATUS_ERROR_FALLBACK = "error_fallback";
const LIVE_META_STATUS_NEVER_SYNCED = "never_synced";
const LIVE_META_STATUS_STALE = "stale";

export class DashboardCell extends Component {
    renderLiveMetaIfNecessary() {
        const liveMeta = this._getLiveMeta();
        if (!liveMeta) {
            return null;
        }
        const status = liveMeta.status;
        if (status !== LIVE_META_STATUS_ERROR_FALLBACK
            && status !== LIVE_META_STATUS_NEVER_SYNCED
            && status !== LIVE_META_STATUS_STALE) {
            return null;
        }
        const t = this.props.t;
        const tooltipText = this._liveMetaTooltipText(liveMeta, status, t);
        const iconName = status === LIVE_META_STATUS_ERROR_FALLBACK
            ? "exclamation-triangle"
            : "info-circle";
        const containerClass = status === LIVE_META_STATUS_ERROR_FALLBACK
            ? "warning-icon-container me-2"
            : "info-icon-container me-2";
        return (
            <div className={containerClass} key="live-meta">
                <FaIcon iconName={iconName}/>
                <div className="warning-tooltip">
                    <div className="warning-tooltip-body">
                        <p className="warning-tooltip-text">{tooltipText}</p>
                    </div>
                </div>
            </div>
        );
    }

    _getLiveMeta() {
        if (this.props.liveMeta) return this.props.liveMeta;
        const columnData = this.props.columnData || this.props.data;
        return columnData && columnData.live_meta ? columnData.live_meta : null;
    }

    _liveMetaTooltipText(liveMeta, status, t) {
        const fetched = this._formatLiveMetaDatetime(liveMeta.fetched_at);
        if (t) {
            if (status === LIVE_META_STATUS_NEVER_SYNCED) {
                return t('dashboard.live_meta.never_synced');
            }
            if (status === LIVE_META_STATUS_ERROR_FALLBACK) {
                return t('dashboard.live_meta.error_fallback', {fetched_at: fetched});
            }
            return t('dashboard.live_meta.stale', {fetched_at: fetched});
        }
        // Fallback si no hay traducción disponible en el contexto
        if (status === LIVE_META_STATUS_NEVER_SYNCED) {
            return "Todavía no se trajeron datos de la plataforma para esta métrica.";
        }
        if (status === LIVE_META_STATUS_ERROR_FALLBACK) {
            return `Último dato: ${fetched}. Hubo un error al actualizar desde la plataforma.`;
        }
        return `Datos del ${fetched}. Esperando actualización.`;
    }

    _formatLiveMetaDatetime(isoString) {
        if (!isoString) return "—";
        try {
            const d = new Date(isoString);
            return d.toLocaleString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'});
        } catch (e) {
            return isoString;
        }
    }

    renderWarningIfNecessary() {
        if (this.props.data !== undefined && this.props.data.has_meta_actions_and_are_not_set || this.props.hasMetaActionsAndAreNotSet) {
            const buId = this.props.businessUnitId;
            const baseUrl = APP_URL && APP_URL.endsWith('/') ? APP_URL.slice(0, -1) : APP_URL;
            const href = buId && baseUrl ? `${baseUrl}/business-unit/${buId}/accounts` : null;
            return (
                <div className="warning-icon-container me-2">
                    <FaIcon iconName="exclamation-triangle"/>
                    <div className="warning-tooltip">
                        <div className="warning-tooltip-body">
                            <p className="warning-tooltip-text">Para poder monitorear correctamente las conversiones y su CPA <span style={{fontWeight:"bold"}} >deberás seleccionar al menos una acción de conversión</span>. <br/><br/><br/>{href ? <a href={href} target="_blank" rel="noopener noreferrer">Configurar ahora.</a> : null}</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (this.props.budgetIsNotSet === true || (this.props.data && this.props.data.budget_is_not_set)) {
            const buId = this.props.businessUnitId;
            const baseUrl = APP_URL && APP_URL.endsWith('/') ? APP_URL.slice(0, -1) : APP_URL;
            const href = buId && baseUrl ? `${baseUrl}/business-unit/${buId}/` : null;
            return (
                <div className="warning-icon-container me-2">
                    <FaIcon iconName="exclamation-triangle"/>
                    <div className="warning-tooltip">
                        <div className="warning-tooltip-body">
                            <p className="warning-tooltip-text">Para monitorear correctamente el presupuesto de la línea de control debe especificar un presupuesto. <br/><br/><br/>{href ? <a href={href} target="_blank" rel="noopener noreferrer">Configurar ahora</a> : null}</p>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }

    processingCssClasses() {
        // Si viene con props.data
        if(this.props.data !== undefined && this.props.data.status !== undefined && this.props.data.status === COLUMN_STATUS_PROCESSING) {
            return "processing"
        }

        // Si viene con props.statuss
        if(this.props.status !== undefined && this.props.status === COLUMN_STATUS_PROCESSING) {
            return "processing"
        }

        return "";
    }
}
